import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function GuidancePanel({ title, paragraphs, items }) {
    return (
        <MKBox
            height="100%"
            p={{ xs: 3, md: 4 }}
            borderRadius="xl"
            bgColor="white"
            sx={{
                boxShadow:
                    "0 0 0 1px rgba(0, 0, 0, 0.06), 0 1px 2px -1px rgba(0, 0, 0, 0.06), 0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
        >
            <MKTypography variant="h3" color="dark" mb={2} sx={{ textWrap: "balance" }}>
                {title}
            </MKTypography>
            {paragraphs.map((paragraph) => (
                <MKTypography
                    key={paragraph}
                    variant="body2"
                    color="text"
                    mb={2}
                    sx={{ textWrap: "pretty" }}
                >
                    {paragraph}
                </MKTypography>
            ))}
            {items.length > 0 && (
                <MKBox component="ul" pl={3} mb={0}>
                    {items.map(({ title: itemTitle, text }) => (
                        <MKTypography
                            component="li"
                            key={`${itemTitle}-${text}`}
                            variant="body2"
                            color="text"
                            mb={1.5}
                            sx={{ textWrap: "pretty" }}
                        >
                            {itemTitle && <strong>{itemTitle}: </strong>}
                            {text}
                        </MKTypography>
                    ))}
                </MKBox>
            )}
        </MKBox>
    );
}

GuidancePanel.defaultProps = {
    paragraphs: [],
    items: [],
};

GuidancePanel.propTypes = {
    title: PropTypes.string.isRequired,
    paragraphs: PropTypes.arrayOf(PropTypes.string),
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            text: PropTypes.string.isRequired,
        })
    ),
};

function ServiceGuidance({ advantages, advice }) {
    return (
        <Grid container spacing={3} alignItems="stretch">
            <Grid item xs={12} md={6}>
                <GuidancePanel title="Avantaj client" {...advantages} />
            </Grid>
            <Grid item xs={12} md={6}>
                <GuidancePanel title="Sfaturile noastre" {...advice} />
            </Grid>
        </Grid>
    );
}

ServiceGuidance.propTypes = {
    advantages: PropTypes.shape({
        paragraphs: PropTypes.arrayOf(PropTypes.string),
        items: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    advice: PropTypes.shape({
        paragraphs: PropTypes.arrayOf(PropTypes.string),
        items: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
};

export default ServiceGuidance;
